module.exports = __webpack_public_path__ + "img/1499419230.919e9d31.jpg";